import PropTypes from "prop-types";

import { useWebReviewScore } from "../../hooks/useWebReviewScore";
import { BaseRating } from "./BaseRating";

const BaseGridRatingHorizontal = ({ classNames, ratingLabelOverride }) => {
	const { score, ratingLabel } = useWebReviewScore();
	if (score === 0) return null;

	return (
		<div className={classNames?.wrapper}>
			<p className={classNames?.score}>{score.toFixed(1)}</p>
			<div className={classNames?.stars}>
				<BaseRating
					className={classNames?.starSize}
					precision={0.1}
					filledColor={classNames?.starColor}
					score={score}
				/>
				<p className={classNames?.count}>
					{ratingLabelOverride ?? ratingLabel}
				</p>
			</div>
		</div>
	);
};

export default BaseGridRatingHorizontal;

BaseGridRatingHorizontal.propTypes = {
	classNames: PropTypes.object,
	ratingLabelOverride: PropTypes.string,
};
